import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=256c16bc&"
import script from "./Ticket.vue?vue&type=script&lang=ts&"
export * from "./Ticket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256c16bc')) {
      api.createRecord('256c16bc', component.options)
    } else {
      api.reload('256c16bc', component.options)
    }
    module.hot.accept("./Ticket.vue?vue&type=template&id=256c16bc&", function () {
      api.rerender('256c16bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/Ticket.vue"
export default component.exports